import { useEffect, useState } from 'react';

export const useDocumentViewErrorListener = () => {
  const [hasError, setHasError] = useState<boolean>(false);

  useEffect(() => {
    const handleError = () => {
      setHasError(true);
    };

    window.addEventListener('error', handleError);

    return () => {
      window.removeEventListener('error', handleError);
    };
  }, []);

  return {
    hasError,
  };
};
